import styled from 'styled-components';

const Div = styled.div`
  > * + * {
    margin-top: 10px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 20px;
  padding-bottom: 20px;
`;

const DropZone = styled.div`
  flex: 1;
  display: block;
  flex-direction: column;
  align-items: center;
  align-content: center;
  padding: 35px 25px 35px 25px;
  width: 100%;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${({ theme }) => theme.COLOR_GREY4};
  border-style: dashed;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  color: #000;
  outline: none;
  transition: border 0.24s ease-in-out;
  height: 468px;
  border-style: ${(props) => (props.isDropped ? 'solid' : 'dashed')};
  border-color: ${(props) => (props.isDropped ? 'green' : '#bdbdbd')};
  background-color: ${(props) => (props.isDropped ? '#0080002b' : '#fafafa')};
`;

const DropHere = styled.div`
  justify-content: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  padding: 35px 25px 35px 25px;
  width: 100%;
  height: 198px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${({ theme }) => theme.COLOR_GREY4};
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  color: #000;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

const styledFileUploader = {
  Div,
  DropZone,
  DropHere,
};

export default styledFileUploader;
